import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { YesNoPipe } from './yes-no.pipe';
import { NaPipe } from './na.pipe';
import { DayJsProvider } from './dayjs.provider';
import { PlotlyProvider } from './plotly.provider';
import { InstallTimePipe } from './install-time.pipe';

@NgModule({
    imports: [CommonModule],
    providers: [DayJsProvider, PlotlyProvider],
    declarations: [YesNoPipe, NaPipe, InstallTimePipe],
    exports: [YesNoPipe, NaPipe, InstallTimePipe],
})
export class ClientSharedUtilityCommonModule {}
